// @flow
import React, { useCallback } from "react";
import Modal from "components/Modal";
import ItemViewWorkflow from "components/CommandActions/itemViews/itemView_workflow";
import Icons from "@hs/icons";
import { useModalPostMessageHandler } from "hooks";
import { createModal } from "react-modal-promise";
import { getLocalizedText } from "data/utils";
import CommandActionHandler from "components/CommandActions";
import { produce } from "immer";
import styles from "./WorkflowActionPanel.module.css";

type Props = {
    /** react-modal-promise: whether to show dialog */
    open: boolean,
    /** react-modal-promise: callback when user closes Dialog */
    close: () => void,
};

/**
 * renders a docked modal as the actionPanel
 */
const WorkflowActionPanel = ({ open, close, contextProps }: Props) => {
    useModalPostMessageHandler(close);
    const { itemUri } = contextProps;
    const handleClick = useCallback(
        (action: ItemActionConfig) =>
            CommandActionHandler(
                "link",
                produce({}, (draft) => {
                    draft = Object.assign(draft, contextProps, {
                        asModal: true,
                        docked: true,
                        title: action.title,
                        url: action.url,
                    });
                })
            ),
        [contextProps]
    );
    return (
        <Modal
            docked
            scroll
            show={open !== false}
            onHide={close}
            dataTest="actionPanel"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <Icons.Custom
                        className={styles.icon}
                        icon="fa-regular fa-square-check"
                    />
                    <span className={styles.title}>
                        {getLocalizedText("$actionCategory:wf.name")}
                    </span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ margin: 15 }}>
                <ItemViewWorkflow itemUri={itemUri} onClick={handleClick} />
            </Modal.Body>
        </Modal>
    );
};
WorkflowActionPanel.displayName = "WorkflowActionPanel";

const openWorkflowActionPanel = createModal(WorkflowActionPanel);
export { WorkflowActionPanel, openWorkflowActionPanel };
